<template>
  <div class="page-old-cars" :class="{ 'show-menu':showMenu, 'filtered': carsByFilter && carsByFilter.length }">
    <vue-headful title="Notaðir bílar | bilaskra.is" description="Bílasölur"/>
    <ad v-if="$device.tablet()" :ad="ad" :class="{'ad-front-tablet':$device.tablet()}" :ad-load="loadAd" />
    <Aside
        :class="{'show-menu':showMenu,'filters-with-ad':ad && $device.tablet()}"
        :brands="brands"
        :brand_model="brand_model"
        :fuel_type="fuel_type"
        :flokkar="flokkar"
        :other="other"
        :categories="categories"
        :vehicle_type="vehicle_type"
        :extra_type="extraType"
        :selected_filters_count="selected_filters_count"
        :result_count="resultCount"
        :filters="filters"
        :girartegund="girartegund"
    />

    <div v-show="showContentIosApp" class="old-cars-content">
      <template v-if="hasCarsSlider && loadSliders">
        <ad v-if="!$device.tablet()" :ad="ad" :ad-load="loadAd" />
<!--        <div class="super-block">
          <k7-banner v-if="loadAd && isK7"/>
          &lt;!&ndash;          <new-banner v-else-if="newBanner" />&ndash;&gt;
          <ad v-else-if="loadAd && ad" :ad="ad"/>
          <AdUnit v-else-if="loadAd"/>
          <div style="opacity: 0;" v-else class="adunit-block"></div>

          <MobileAppStore v-if="!isK7"/>
        </div>-->

        <template v-if="mounted" v-for="(val, index) in getSliderCars">
          <DealerCarsSlider
              v-if="!val.ad"
              :key="index"
              :cat_id="val.fuel_id"
              :scar="val.cars"
              :girartegund="$store.state.girartegund"
              :title="val.title"
              :subtitle="val.title.toLowerCase()"
              :dealers="true"
          />
          <template v-else-if="val.ad">
              <ad-car class="mobile-ad-slider" :key="index" :ad="{empty: true}" />
          </template>
<!--          <single-ad class="mobile-ad-slider" v-if="val.ad" :key="index" :ad="val" />-->
        </template>
      </template>

      <k7-banner v-if="isK7" style="margin-bottom: 25px;"/>
      <ResultsHeader
          v-if="carsByFilter && carsByFilter.length && filtered"
          :filters="addFilersName()"
          :filtersData="filters"
          :total="resultCount"
          :is_sub="isSub"
          :subscriber="subscriber"
      />
      <div v-if="carsByFilter && carsByFilter.length && filtered" class="results-cards-wrap" id="results-cards">
        <VCar v-for="(val, index) in carsByFilter"
              :key="index"
              :car="val"
              :girartegund="girartegund"
              :index="index"
              :scrollTop="true"
              :filter="cleanFilters(filters)"
        />
        <div style="font-size: 18px; color: red;" id="load_more">Load More</div>
      </div>

      <CarsNotFound v-if="carsNotFound" :filter="filters" :image="notFoundImage" :allow-subscribe="true"/>
    </div>
    <Footer class="footer-main" v-if="isIosApp && !showMenu"/>
    <phone-nav-btn v-if="!$store.state.isApp"/>
  </div>
</template>

<script>
import AdUnit from "@/components/Dealers/AdUnit";
import MobileAppStore from "@/components/Dealers/MobileAppStore";
import Aside from "@/components/OldCars/Aside.vue";
import scroll from "@/helpers/scroll";
import ResultsHeader from "@/components/ResultsHeader.vue";
import VCar from "@/components/global/Car.vue";
import DealerCarsSlider from "@/components/Dealers/DealerCarsSlider";

import CarsNotFound from "@/components/Dealers/CarsNotFound"

import routesNames from '@/router/constants'
import {mapActions, mapMutations} from 'vuex';
import Footer from "@/components/Footer";
import k7Banner from "@/components/k7/Banner"
import PhoneNavBtn from "@/components/global/PhoneNavBtn";
import Ad from "@/components/ad/Index"
import AdCar from "@/components/global/AdCar";


import post from "@/mixins/oldCars/post";
import data from "@/mixins/oldCars/data";
import watch from "@/mixins/oldCars/watch";
import ad from "@/mixins/oldCars/ad";
import computed from "@/mixins/oldCars/computed";
import pageLifeCycle from "@/mixins/oldCars/pageLifeСycle";
import allCars from "@/mixins/allCars";
import oldCars from "@/mixins/oldCars";


export default {
  metaInfo() {
    return {
      title: this.pageTitle,
      titleTemplate: '%s | bilaskra.is',
      meta: [
        {name: 'og:title', content: 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum'},
        {
          name: 'og:description',
          content: 'Finndu bíla á tilteknu verði, af tiltekinni stærð eða gerð og berðu saman kostina sem umboðin bjóða.'
        },
        {name: 'og:image', content: this.defaultShareImage},
        {name: 'og:image:width', content: 1200},
        {name: 'og:image:height', content: 630},
      ],
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
  mixins: [
    oldCars, post, data, watch, ad, computed, pageLifeCycle, allCars
  ],
  components: {
    AdUnit,
    MobileAppStore,
    VCar,
    Aside,
    ResultsHeader,
    DealerCarsSlider,
    CarsNotFound,
    Footer,
    PhoneNavBtn,
    k7Banner,
    Ad,
    AdCar
  },
  beforeRouteLeave(to,from,next) {
    if (!['Car', 'OldCars'].includes(from.name) || !['Car', 'OldCars'].includes(to.name)) this.$store.state.sorting = null
    if(to.name != "Car"){
      this.$store.state.oldCarsPosition = 0;
      this.$store.state.oldCarsLoadedCars = [];
      this.oldCarsLoadedData = false;
      this.setData({
        field: 'moduleOldCars.cars.items',
        data: []
      })
    }
    next();
  },
  methods: {
    ...mapMutations('ad',{
      setAdList:"setAdList"
    }),
    ...mapActions({
      'getAd': "ad/GET",
      //'sendViewsAd': 'ad/SEND_VIEWS_STATISTIC'
    }),
    ...mapMutations({
      setData: 'SET_DATA',
      setSpecialText: 'setSpecialText',
      setScrollTo: 'setScrollTo'
    }),
    ...mapMutations([
      "setShowMenu",
      "setLastCarPageVisit"
    ]),
    handleScroll() {
      this.$store.state.scrollTop = scroll.offsetTop();

      this.$store.state.oldCarsPosition = scroll.offsetTopPage();
      if (this.carsLoaded && this.$route.path === routesNames.oldCars) {
        this.setScrollTo(scroll.offsetTopPage());

        this.setData({
          field: 'moduleOldCars.cars.scrollTop',
          data: scroll.offsetTopPage()
        })
      }
    },
    scrolling() {
      if (this.carsLoaded) {
        scroll.to(this.scrollTopCars);
        scroll.to(this.$store.state.oldCarsPosition);
      }
    },

    loadMore() {
      /*
      let scrollElement = scroll.getScrollElement();
      let pageOffsetTop = scrollElement.scrollTop + (window.innerHeight - 200);

      if (this.selectedFiltersCount) {
        document.querySelectorAll(".ad_car_search_block:not(.see-ad)").forEach(e => {
          if (e.offsetTop < pageOffsetTop) {
            e.classList.add("see-ad");
            this.sendViewsAd({id: e.getAttribute("data-id"), used: 1});
          }
        });
      } else {
        document.querySelectorAll(".index-slider:not(.see-ad)").forEach(e => {
          if (e.offsetTop < pageOffsetTop && e.querySelector(".ad_car_search_block")) {
            const id = e.querySelector(".ad_car_search_block").getAttribute("data-id");
            this.sendViewsAd({id: id, used: 1 , isSlider: 1});
            e.classList.add("see-ad");
          }
        });
      }*/

      if (document.querySelector("#load_more")) {
        if (
            //document.querySelector("html,body").scrollTop + window.innerHeight >
            scroll.offsetTopPage() + (window.innerHeight * 3) >
            document.querySelector("#load_more").offsetTop &&
            !this.busy
        ) {
          this.busy = true;
          this.post();
        }
      }
    },
    getFuelType(ft, ft2) {
      let res = this.fuel_type[ft] ? this.fuel_type[ft].name : "";
      if (ft2 != "1000" && this.fuel_type[ft2]) {
        res += ", " + this.fuel_type[ft2].name;
      }
      return res;
    },
  }
};
</script>
